const actions = {
  CREATE_RELAY_ITEM: 'CREATE_RELAY_ITEM',
  CREATE_RELAY_ITEM_ENDED: 'CREATE_RELAY_ITEM_ENDED',
  SEARCH_RELAY_ITEMS: 'SEARCH_RELAY_ITEMS',
  SEARCH_RELAY_ITEMS_ENDED: 'SEARCH_RELAY_ITEMS_ENDED',
  UPDATE_RELAY_ITEM: 'UPDATE_RELAY_ITEM',
  UPDATE_RELAY_ITEM_ENDED: 'UPDATE_RELAY_ITEM_ENDED',
  DELETE_RELAY_ITEMS: 'DELETE_RELAY_ITEMS',
  DELETE_RELAY_ITEMS_ENDED: 'DELETE_RELAY_ITEMS_ENDED',
  CREATE_RELAY_ITEM_API: 'CREATE_RELAY_ITEM_API',
  CREATE_RELAY_ITEM_API_ENDED: 'CREATE_RELAY_ITEM_API_ENDED',
  SEARCH_RELAY_ITEM_APIS: 'SEARCH_RELAY_ITEM_APIS',
  SEARCH_RELAY_ITEM_APIS_ENDED: 'SEARCH_RELAY_ITEM_APIS_ENDED',
  FIND_RELAY_ITEM_API: 'FIND_RELAY_ITEM_API',
  FIND_RELAY_ITEM_API_ENDED: 'FIND_RELAY_ITEM_API_ENDED',
  UPDATE_RELAY_ITEM_API: 'UPDATE_RELAY_ITEM_API',
  UPDATE_RELAY_ITEM_API_ENDED: 'UPDATE_RELAY_ITEM_API_ENDED',
  DELETE_RELAY_ITEM_APIS: 'DELETE_RELAY_ITEM_APIS',
  DELETE_RELAY_ITEM_APIS_ENDED: 'DELETE_RELAY_ITEM_APIS_ENDED',
};

export default actions;
